import { reactive, ref, watch } from 'vue';
import type { BudgetGroup } from '@/types/budgetGroups';

interface UseEditBudgetGroupDialogState {
  isOpen: boolean;
  budgetGroup: BudgetGroup | null;
}

const state = reactive<UseEditBudgetGroupDialogState>({
  isOpen: false,
  budgetGroup: null,
});
const isRendered = ref(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
});

export function useEditBudgetGroupDialog() {
  function open(budgetGroup: BudgetGroup) {
    state.budgetGroup = budgetGroup;
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
    state.budgetGroup = null;
  }

  return {
    state,
    isRendered,
    open,
    close,
  };
}
